<template>
  <div class="nav-bar nav-section-scrolling" :class="{ 'd-flex d-md-none': !isDashboard }">
    <nav class="content">
      <div class="site-logo">
        <router-link
          :to="isDashboard ? '/dashboard' : '/'"
          class="site-logo"
          active-class="active"
          @click.native="goToPage"
          ><img src="../assets/logo.png"
        /></router-link>
      </div>
      <div class="menu-links" :class="mobileMenuStatus ? 'show' : 'collapsed'">
        <router-link
          to="/dashboard/nft"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("dashboard.nav.nft") }}</router-link
        >
        <router-link
          to="/dashboard/goldlocker"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("dashboard.nav.goldlocker") }}</router-link
        >
        <div class="d-none d-xl-flex align-items-center gap-2" v-if="user">
          <div class="user-avatar">
            <img :src="user.avatar" alt="Avatar" />
          </div>
          <span class="d-none d-md-inline">{{ $t("dashboard.nav.welcome") }}
            {{ user && user.name ? user.name : "" }}</span>
        </div>
        <span v-if="token" @click="logout">{{
          $t("dashboard.nav.logout")
        }}</span>
        <button @click="switchLang()" class="btn btn-sm btn-info text-white">
          {{ $i18n.locale === "en" ? "中文" : "English" }}
        </button>
      </div>
      <div class="nav-btn" @click="toggleMenu()">
        <div class="user-avatar" v-if="user">
          <img :src="user.avatar" alt="Avatar" />
        </div>
        <div class="user avatar" v-else>
          <img src="../assets/menu-btn.svg" alt="Menu Button" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      isDashboard: false,
      mobileMenuStatus: false,
      showMenuBg: false,
      user: {
        id: null,
        name: "",
        phone: "",
        avatar: "",
      },
      token: "",
    };
  },
  created() {
    this.iniUser();
  },
  methods: {
    iniUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.token = localStorage.getItem("token");
      const currentPath = this.$router.history.current.path.substring(1);
      this.isDashboard = currentPath.startsWith("dashboard");
    },
    switchLang() {
      this.mobileMenuStatus = false;
      if (this.$i18n.locale === "en") {
        this.$i18n.locale = "cn";
      } else {
        this.$i18n.locale = "en";
      }
    },
    toggleMenu() {
      this.mobileMenuStatus = !this.mobileMenuStatus;
    },
    goToPage() {
      this.mobileMenuStatus = false;
      window.scrollTo(0, 0);
    },
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.user = {};
      this.token = "";
      this.$router.push("/login");
      this.mobileMenuStatus = false;
      window.scrollTo(0, 0);
    },
  },
  watch: {
    $route() {
      // const currentPath = this.$router.history.current.path.substring(1);
      this.iniUser();
    },
  },
};
</script>

<style scoped>
.nav-bar {
  height: 80px;
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  transition: all 0.3s ease-out;
}
.nav-bar.nav-section-scrolling {
  background-color: white;
  z-index: 999;
}
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  a,
  a:visited {
    text-decoration: none;
    color: #3b3e51;
  }
  a:hover,
  a.nav-link.active {
    color: #0a58ca;
  }
  .site-logo img {
    max-height: 40px;
  }
  .menu-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 70px;
    left: 0;
    gap: 1rem;
    width: 100%;
    background-color: white;
    padding: 1rem;
    box-sizing: border-box;
    transition: all 0.3s ease-out;
    .login-btn {
      background-color: #ef8200;
      color: white;
      height: 26px;
      padding: 0.1rem 1.5rem;
      display: inline-flex;
      align-items: center;
      border-radius: 1rem;
      margin-left: 0.8rem;
    }
  }
  .menu-links.collapsed {
    visibility: hidden;
    opacity: 50;
    height: 0;
    overflow: hidden;
    z-index: -1;
  }
  .menu-links.show {
    visibility: visible;
    opacity: 100;
    height: auto;
    z-index: 999;
    box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.3);
  }
  .user-avatar {
    width: 42px;
    height: 42px;
    border-radius: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nav-bar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a,
    a:visited {
      text-decoration: none;
      color: #3b3e51;
    }
    a:hover,
    a.nav-link.active {
      color: #0a58ca;
    }
    .menu-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      .login-btn {
        background-color: #ef8200;
        color: white;
        height: 26px;
        padding: 0.1rem 1.5rem;
        display: inline-flex;
        align-items: center;
        border-radius: 1rem;
        margin-left: 0.8rem;
      }
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .nav-bar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a,
    a:visited {
      text-decoration: none;
      color: #3b3e51;
    }
    a:hover,
    a.nav-link.active {
      color: #0a58ca;
    }
    .site-logo img {
      max-height: auto;
    }
    .menu-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      .login-btn {
        background-color: #ef8200;
        color: white;
        height: 26px;
        padding: 0.1rem 1.5rem;
        display: inline-flex;
        align-items: center;
        border-radius: 1rem;
        margin-left: 0.8rem;
      }
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .nav-bar {
    padding: 0;
    position: relative;
  }
  .nav-bar.nav-section-scrolling {
    background-color: linear-gradient(
      180deg,
      #ffffff 65%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  nav {
    .menu-links {
      flex-direction: row;
      position: relative;
      background-color: transparent;
      padding: 0;
      position: relative;
      top: 0;
      width: auto;
    }
    .nav-btn {
      display: none;
    }
    .menu-links.collapsed,
    .menu-links.show {
      visibility: visible;
      opacity: 100;
      height: auto;
      z-index: 999;
      box-shadow: none;
    }
  }
}
</style>
